export default function ResponsiveHeroVideo({ className, desktopSrc, mobileSrc, poster }) {
  return (
    <video
      className={className}
      autoPlay
      loop
      muted
      playsInline
      preload="auto"
      poster={poster}
      disablePictureInPicture
    >
      {mobileSrc ? <source src={mobileSrc} media="(max-width: 780px)" type="video/mp4" /> : null}
      <source src={desktopSrc} type="video/mp4" />
    </video>
  );
}
